import React from "react";
import './master.scss';

// Redux
import { Provider } from "react-redux";
import store from "./services/store";

const Root = ({ children, initialState = {} }) => (
    <React.Fragment>
        <Provider store={store(initialState)}>
            {children}
        </Provider>
    </React.Fragment>
);

export default Root;